export default "<ion-label> {{ dateObj  }} </ion-label>";